<template>
  <div class="template-Add">
    <el-dialog
      title="添加模板"
      :visible.sync="selfVisible"
      width="40%"
      @close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-form-item label="模板名：" prop="templateName">
          <el-input v-model="form.templateName"></el-input>
        </el-form-item>
        <el-form-item label="短信签名：" prop="smsSignName">
          <el-input v-model="form.smsSignName"></el-input>
        </el-form-item>
        <el-form-item label="AK：" prop="accessKeyId">
          <el-input v-model="form.accessKeyId"></el-input>
        </el-form-item>
        <el-form-item label="SK：" prop="smsSecret">
          <el-input v-model="form.smsSecret"></el-input>
        </el-form-item>
        <el-form-item label="模板id：" prop="templateCode">
          <el-input v-model="form.templateCode"></el-input>
        </el-form-item>
        <el-form-item label="变量：" prop="variableParam">
          <el-tag
            :key="index"
            v-for="(tag,index) in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleCloseTag(tag)"
          >{{tag}}</el-tag>
          <el-input
            class="input-new-tag"
            maxlength="12"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>
          <el-button
            v-else
            :disabled="dynamicTags.length >= 5"
            class="button-new-tag"
            size="small"
            @click="showInput"
          >+ New Tag</el-button>
          <p style="color:grey;">(请不要添加变量命为name的值)</p>
        </el-form-item>
        <el-form-item class="submit">
          <el-button
            type="primary"
            :loading="loading"
            @click="handleSave('form')"
          >保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { validateEnglish } from '@/utils/validate';

export default {
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      selfVisible: false,
      form: {
        templateName: '',
        accessKeyId: '',
        smsSecret: '',
        smsSignName: '',
        templateCode: '',
        variableParam: '',
      },
      rules: {
        templateName: [
          { required: true, message: '请输入模板名', trigger: 'blur' },
        ],
        smsSignName: [
          { required: true, message: '请输入模板签名', trigger: 'blur' },
        ],
        accessKeyId: [
          { required: true, message: 'Ak不能为空', trigger: 'blur' },
        ],
        smsSecret: [
          { required: true, message: 'SK不能为空', trigger: 'blur' },
        ],
        templateCode: [
          { required: true, message: '模板id不能为空', trigger: 'blur' },
        ],
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selfVisible = newValue;
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.dynamicTags.length === 0) {
            this.$message.warning('请添加变量');
          } else {
            this.form.variableParam = this.dynamicTags.join(',');
            this.$emit('confirm', this.form);
            return true;
          }
        }
        return false;
      });
    },
    handleClose() {
      this.$emit('close');
      this.dynamicTags = [];
      this.resetForm();
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleCloseTag(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      const { inputValue } = this;
      this.validateTag(inputValue).then(() => {
        this.dynamicTags.push(inputValue);
      });
      this.inputVisible = false;
      this.inputValue = '';
    },
    // 验证
    validateTag(val) {
      return new Promise((resolve, reject) => {
        if (val === '') {
          this.$message.warning('变量名不能为空');
        } else if (!validateEnglish(val)) {
          this.$message.warning('变量名只能为英文字符');
          reject();
        } else if (this.dynamicTags.indexOf(val) !== -1) {
          this.$message.warning('变量名不能相同');
        } else {
          resolve(true);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.template-Add
  padding-top 100px
  .el-form
    width calc(100% - 40px)
    margin 0 auto
    .uploadImg
      flex-row()
      >>>.el-form-item__content
        margin-left 0 !important
    .submit
      margin-top 40px
      text-align center
    .el-tag
      margin-right 10px
      &:first-child
        margin-left 0
      &:last-child
        margin-right 0
    .button-new-tag
      padding 0 8px !important
      height 32px
      line-height 30px
      padding-top 0
      padding-bottom 0
    .input-new-tag
      width 77.73px
      // margin-left 10px
      vertical-align bottom
</style>
